var _rect, _polygon, _rect2, _polygon2, _rect3, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Winner_x5F_Sides_x5F_Hair",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.45743,
    y: 20.01015,
    width: 7.17442,
    height: 6.62254,
    fill: "currentColor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.04464 10.17227 6.2406 13.85307 10.11083 13.85307 6.97975 16.12793 8.17571 19.80873 5.04464 17.53387 1.91356 19.80873 3.10953 16.12793 -.02155 13.85307 3.84867 13.85307 5.04464 10.17227",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.39124,
    y: 13.38758,
    width: 7.17442,
    height: 13.24508,
    fill: "currentColor"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.97845 3.54969 16.17442 7.23049 20.04464 7.23049 16.91356 9.50535 18.10953 13.18616 14.97845 10.91129 11.84737 13.18616 13.04334 9.50535 9.91226 7.23049 13.78249 7.23049 14.97845 3.54969",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.32505,
    y: 16.69885,
    width: 7.17442,
    height: 9.93381,
    fill: "currentColor"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.91226 6.86096 26.10823 10.54176 29.97845 10.54176 26.84737 12.81662 28.04334 16.49743 24.91226 14.22257 21.78119 16.49743 22.97715 12.81662 19.84607 10.54176 23.7163 10.54176 24.91226 6.86096",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingIcon);
export default __webpack_public_path__ + "static/media/RankingIcon.eb15e1f5a1bbe737a151752f82ee4887.svg";
export { ForwardRef as ReactComponent };